import script from "./FileListComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FileListComponent.vue?vue&type=script&setup=true&lang=js"

import "./FileListComponent.vue?vue&type=style&index=0&id=463097ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-463097ba"]])

export default __exports__